var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubDepartmentsVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 22,
    viewBox: "0 0 13 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 5",
    d: "M1 19H0.5V19.5H1V19ZM7.33333 19C7.33333 20.4728 8.52724 21.6667 10 21.6667C11.4728 21.6667 12.6667 20.4728 12.6667 19C12.6667 17.5272 11.4728 16.3333 10 16.3333C8.52724 16.3333 7.33333 17.5272 7.33333 19ZM0.5 0V19H1.5V0H0.5ZM1 19.5H10V18.5H1V19.5Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubDepartmentsVector);
export default __webpack_public_path__ + "static/media/subDepartmentsVector.47d8bed3b6b7c8a4b0ef169ecc8a81cb.svg";
export { ForwardRef as ReactComponent };